<template>
    <van-overlay
        :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"
        v-if="companyVerifyDialog"
        :show="companyVerifyDialog"
    >
        <div class="company-verify-dialog">
            <div class="company-verify-dialog_content">
                <p>验证公司名称</p>
                <p>为了公司信息安全，请输入完整公司名称进行验证</p>
                <div class="verify-box">
                    <span
                        v-for="(item, index) in companyNames.split('')"
                        :key="index"
                        :class="{ 'input-box': index == random1 || index == random2 }"
                    >
                        <template v-if="index == random1 || index == random2"
                            ><el-input v-if="index == random1" v-model="value1" :maxlength="1" /><el-input
                                v-else
                                v-model="value2"
                                :maxlength="1"
                        /></template>
                        <template v-else>{{ item }}</template>
                    </span>
                </div>
                <el-button type="text" @click="handleClickConfirm">确定</el-button>
            </div>
        </div>
    </van-overlay>
</template>
<script>
export default {
    name: "CompanyVerify",
    props: {
        companyVerifyDialog: {
            type: Boolean,
            default: false,
        },
        companyNames: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            random1: 0,
            random2: 0,
            value1: "",
            value2: "",
        };
    },
    created() {
        let rand = this.validateCompanyName(this.companyNames);
        this.random1 = rand[1] ? rand[1] : 0;
        this.random2 = rand[0] ? rand[0] : 1;
    },
    methods: {
        validateCompanyName(companyName) {
            // 定义要规避的字符串
            const excludeStr = "有限公司";

            // 检查公司名称是否包含“有限公司”
            if (companyName.includes(excludeStr)) {
                // 移除“有限公司”
                const filteredName = companyName.replace(excludeStr, "");

                // 随机选择两个字符的下标
                if (filteredName.length < 2) {
                    return []; // 如果剩余字符少于2个，返回空数组
                }

                const indices = [];
                while (indices.length < 2) {
                    const randomIndex = Math.floor(Math.random() * filteredName.length);
                    if (!indices.includes(randomIndex)) {
                        indices.push(randomIndex);
                    }
                }

                return indices;
            } else {
                return []; // 如果没有“有限公司”，返回空数组
            }
        },
        handleDialogClose() {
            this.$emit("update:companyVerifyDialog", false);
        },
        handleClickConfirm() {
            if (!this.value1 || !this.value2) return;
            const text1 = this.random1 > 0 ? this.companyNames.slice(0, this.random1) : "";
            const text2 = this.companyNames.slice(this.random1 + 1, this.random2);
            const text3 = this.companyNames.slice(this.random2 + 1);
            const name = `${text1}${this.value1}${text2}${this.value2}${text3}`;
            if (name == this.companyNames) {
                this.$toast({
                    message: "验证成功",
                    type: "success",
                    duration: 1000,
                    onClose: () => {
                        this.$emit("success");
                    },
                });
            } else {
                this.$toast("验证失败，请重新填写");
                this.value1 = "";
                this.value2 = "";
            }
        },
    },
};
</script>
<style lang="scss">
.company-verify-dialog {
    width: 100%;
    height: 100%;
    position: relative;
}
.company-verify-dialog_content {
    width: 280px;
    height: 178px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 12px 48px 16px rgba(0, 0, 0, 0.06);
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding-top: 24px;
    box-sizing: border-box;

    p {
        margin: 0;
        font-size: 10px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 15px;
        color: rgba(153, 153, 153, 1);
    }

    p:nth-child(1) {
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 24px;
        color: rgba(34, 34, 34, 1);
        margin-bottom: 4px;
    }

    .verify-box {
        padding: 10px;
        min-height: 44px;
        border-bottom: 1px solid rgba(232, 232, 232, 1);

        span {
            font-size: 16px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 24px;
            color: rgba(51, 51, 51, 1);
        }
    }

    .el-button {
        width: 100%;
    }

    .input-box {
        margin: 0 8px;

        & + .input-box {
            margin-left: 0;
        }
    }

    .el-input {
        width: 24px;
        height: 24px;

        .el-input__inner {
            height: 24px;
            line-height: 24px;
            padding: 0;
            text-align: center;
        }
    }
    .el-button {
        height: 44px;
        line-height: 44px;
        padding: 0;
        font-size: 16px;
        font-weight: 400;
        color: rgba(41, 144, 255, 1);
    }
}
</style>
